/** Resolvers */

export * from './SEO.resolver';
export * from './GTM.resolver';
